module.exports = __webpack_public_path__ + "static/media/logo-sm.89749573.svg";